import React from "react";

export function AwardsActions() {
	return (
		'Awards Actions'
	)
}
